import GetDocumentsInvoice from '@/components/custom/erp/get-documents-v2';
import { AritoFormV2 } from '@/components/custom/erp';
import type { FormDialogProps } from './types';
import { FormHeader } from './FormHeader';
import { useFormDialog } from './hooks';
import { FormTabs } from './FormTabs';
import BottomBar from './BottomBar';

const FormDialog = (props: FormDialogProps) => {
  const dialog = useFormDialog(props);
  const { totals } = dialog.detail;

  return (
    <>
      <AritoFormV2
        mode={dialog.formMode}
        initialData={dialog.initialValues}
        title={dialog.title}
        schema={dialog.schema}
        actionButtons={dialog.actionButtons}
        subTitle='Hóa đơn bán hàng'
        className='h-[100dvh] max-h-[100dvh] overflow-hidden'
        onSubmit={dialog.submit}
        onClose={dialog.onClose}
        headerFields={<FormHeader dialog={dialog} />}
        tabs={FormTabs(dialog)}
        bottomBar={
          dialog.activeTab === 'info' ? (
            <BottomBar
              tong_sl={totals.tong_sl}
              tong_tien={totals.tong_tien}
              tong_thue={totals.tong_thue}
              tong_tien_von={totals.tong_tien_von}
              tong_thanh_toan={totals.tong_thanh_toan}
              tong_ck={totals.tong_ck}
              state={dialog.formState.state}
            />
          ) : null
        }
      />

      {dialog.documents.open ? (
        <GetDocumentsInvoice
          onSearch={dialog.documents.selection}
          onClose={dialog.documents.close}
          chungTuType='DHB'
          detailColumns={dialog.documents.columns}
        />
      ) : null}
    </>
  );
};

export default FormDialog;
